// removed by extract-text-webpack-plugin
module.exports = {"bigpar":"src-components-StartUp----StartUp-module---bigpar---2HaxY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StartUp/StartUp.module.scss
// module id = 436
// module chunks = 110243015079028